import type { ComponentSchema } from "../../../../../schema-types"

export const schema: ComponentSchema = {
  type: 'recent-products',
  label: 'Recently Viewed Products',
  description: 'A horizontal slider of products the visitor has recently viewed (stored in localStorage — no API call).',
  supportedPages: ['home', 'shop', 'product', 'category', 'cart'],
  variants: [{ id: 'v1', label: 'V1 (Horizontal Slider)' }],
  commonFields: [
    { key: 'title', label: 'Section Title', type: 'string', default: 'Recently Viewed' },
  ],
}
